<template lang="html">
  <div id="bolsa-trabajo-d-page">

    <section class="container main-section">
      <div class="row">
        <div class="col-12">
          <div class="col-s-title">
            <h2 class="title"></h2>
          </div>
        </div>

        <div class="col-12 col-content">
          <h1 class="job-name">{{ noticia.title }}</h1>
          <h5 class="job-date">{{ noticia.date }}</h5>
          <!-- <h4 class="job-salary">$12,000.00</h4> -->
          <!-- <div class="box-bubbles">
            <span class="_bubble">$12,000.00 Mensual</span>
            <span class="_bubble">Tiempo completo</span>
          </div> -->

          <div class="box-descr" v-html="noticia.body"></div>
          <br><br>
          <div style="text-align: center;">
            <b-button style="width: 250px;background-color: #1b5985;" type="btn" class="btn-more outline" @click="$refs.modalPostulate.open()">Postularse</b-button>
          </div>
          
        </div>

        <sweet-modal ref="modalPostulate">
            <b-form class="white-box" @submit.prevent="saveForm()">
                <h2 style="color:#1b5985"><b>{{ noticia.title }}</b></h2>
                <p>Aplicar ahora</p>
                <br>
                <hr>
                <br>
                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Nombre:</label>   
                    <b-form-input id="user-name" type="text" v-model="form.name" size="sm" required/>
                </div>
                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Edad:</label>   
                    <b-form-input id="user-name" type="text" v-model="form.age" size="sm" required/>
                </div>
                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Número de celular:</label>   
                    <b-form-input id="user-name" type="text" v-model="form.phone" size="sm" required/>
                </div>
                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Correo electrónico:</label>   
                    <b-form-input id="user-name" type="text" v-model="form.email" size="sm" required/>
                </div>

                <div class="row mx-0 no-gutters">
                    <div class="col-md-12">
                        <b-form-group class="custom-input" label="Horario en el que prefieres que te contactemos:" label-for="i-entrega">
                            <v-select v-model="form.schedule" :options="['6:00 am a 1:00 pm', '2:00 pm a 4:00 pm']" />
                        </b-form-group>
                    </div>
                </div>

                <div class="row mx-0 no-gutters">
                    <div class="col-md-12">
                        <b-form-group class="custom-input" label="¿Por cuál medio se enteró de la vacante?:" label-for="i-entrega">
                            <v-select v-model="form.how_did_find" :options="['Correo','Empleo nuevo','Facebook','Instagram','Google','Recomendación','Reclutamiento en campo','Volanteo','Espectacular','Valla móvil']" />
                        </b-form-group>
                    </div>
                </div>

                <div class="row mx-0 no-gutters">
                    <div class="col-md-12">
                        <b-form-group class="custom-input" label="Disposición a rotar turnos:" label-for="i-entrega">
                            <v-select v-model="form.able_to_roll" :options="['Si', 'No']" />
                        </b-form-group>
                    </div>
                </div>

                <div class="row mx-0 no-gutters">
                    <div class="col-md-12">
                        <b-form-group class="custom-input" label="Nivel académico o grado de estudios:" label-for="i-entrega">
                            <v-select v-model="form.has_title" :options="['Preparatoria', 'Tecnico','Licenciatura']" />
                        </b-form-group>
                    </div>
                </div>


                <div class="row mx-0 no-gutters">
                    <div class="col-md-12">
                        <b-form-group class="custom-input" label="¿Tienes Visa?:" label-for="i-entrega">
                            <v-select v-model="form.has_visa" :options="['Si', 'No']" />
                        </b-form-group>
                    </div>
                </div>
                
                <div class="row mx-0 no-gutters">
                    <div class="col-md-12">
                        <b-form-group class="custom-input" label="¿Tienes Carro?:" label-for="i-entrega">
                            <v-select v-model="form.has_car" :options="['Si', 'No']" />
                        </b-form-group>
                    </div>
                </div>

                

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">¿Escribes inglés? | {{form.english_writing_level}}%:</label>   
                    <b-form-input id="user-name" type="range" v-model="form.english_writing_level" size="sm" />
                </div>
                <div class="custom-input _p">
                    <label class="col-form-label pt-0">¿Hablas inglés? | {{form.english_speaking_level}}%:</label>   
                    <b-form-input id="user-name" type="range" v-model="form.english_speaking_level" size="sm" />
                </div>

                <b-form-group class="col-lg-12 custom-group-s1" label="CV (pdf)">
                    <div class="col-sm-9">
                        <div class="fileinput fileinput-new" data-provides="fileinput">
                          <div class="fileinput-preview fileinput-exists thumbnail" style="max-width: 400px; max-height: 300px">
                          </div>
                          <div>
                            <span class="btn btn-white btn-file">
                              <input type="file" accept=".pdf,image/*" name="cv">
                            </span>
                          </div>
                        </div>
                    </div>
                </b-form-group>

                <b-form-group class="col-lg-12 custom-group-s1" label="Me interesan vacantes de:">
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="form.tijuana"
                        name="checkbox-1"
                        :value="1"
                        :unchecked-value="0"
                      >
                      Tijuana
                    </b-form-checkbox>
                    <b-form-checkbox
                        id="checkbox-2"
                        v-model="form.rosarito"
                        name="checkbox-2"
                        :value="1"
                        :unchecked-value="0"
                      >
                      Rosarito
                    </b-form-checkbox>

                    <b-form-checkbox
                        id="checkbox-3"
                        v-model="form.tecate"
                        name="checkbox-3"
                        :value="1"
                        :unchecked-value="0"
                      >
                      Tecate
                    </b-form-checkbox>
                </b-form-group>

                <br><br>
                <div style="text-align: center;">
                <b-button style="width: 250px;background-color: #1b5985;" type="sumbit" class="btn-more outline" >Postularse</b-button>
              </div>
             
                

            </b-form>
        </sweet-modal>

        <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
          <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
          <div v-html="modal.msg"></div>
          <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
            <b-button class="btn btn-success" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/')">Regresar a Home <i class="color-white fas fa-home"></i></b-button>
          </div>
        </sweet-modal>

      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      noticia: [],
      id: null,
      form:{
        name:null,
        age:null,
        phone:null,
        email:null,
        schedule:null,
        how_did_find:null,
        able_to_roll:null,
        has_title:null,
        has_visa:null,
        has_car:null,
        english_writing_level:null,
        english_speaking_level:null,
        tijuana:0,
        rosarito:0,
        tecate:0,
        blogs_id:null,
        
      },
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
    }
  },

  methods: {
    getContent: function(){
        axios.get(tools.url('/api/blogs/'+this.id)).then((response)=>{
            this.noticia = response.data;
        });
    },
    saveForm: function(){
      this.modal.block = true;
        this.modal.icon = '';
        this.modal.msg = 'Cargando, por favor espere...';
        this.$refs.modal.open();

        var formData = new FormData();
        formData.append("cv", jQuery('input[name="cv"]')[0].files[0]);
        formData.append("name", this.form.name);
        
        formData.append("age", this.form.age);
        formData.append("phone", this.form.phone);
        formData.append("email", this.form.email);
        
        formData.append("schedule", this.form.schedule);
        formData.append("how_did_find", this.form.how_did_find);
        formData.append("able_to_roll", this.form.able_to_roll);
        formData.append("has_title", this.form.has_title);
        formData.append("has_visa", this.form.has_visa);
        formData.append("has_car", this.form.has_car);
        formData.append("english_writing_level", this.form.english_writing_level);
        formData.append("english_speaking_level", this.form.english_speaking_level);
        formData.append("tijuana", this.form.tijuana);
        formData.append("rosarito", this.form.rosarito);
        formData.append("tecate", this.form.tecate);
        
        axios.post(tools.url('/api/postulates/'+this.id),formData).then((response)=>{
            this.$refs.modalPostulate.close()
            this.form = {};
            this.modal.block = false;
            this.modal.icon = "success";
            this.modal.msg = "Registro guardado correctamente";


          }).catch((error)=>{
            console.log(error);
            this.modal.block = false;
            this.modal.icon="error";
            this.modal.msg = "Error al guardar la informacion";
            
          
        });
    }
  },

  watch: {
        "$route.params.id" : function(v){
            this.id = this.$root._getURLID(this.$route.params.id);
            this.getContent();
        },
    },

  mounted(){
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getContent();
  }
}
</script>
